var _g, _path, _path2, _g2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 125.551h512v37.27H0zM0 200.091h512v37.27H0zM0 274.641h512v37.27H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M0 311.911h512v37.27H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 349.181h512v37.27H0z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.828 423.725h494.345a8.829 8.829 0 0 0 8.828-8.828v-28.445H0v28.445a8.828 8.828 0 0 0 8.828 8.828zM512 125.549V97.104a8.829 8.829 0 0 0-8.828-8.828H8.828A8.83 8.83 0 0 0 0 97.104V274.637h512v-37.272H176.552v-37.272H512v-37.272H176.552v-37.272H512z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M176.552 162.821h-69.64V88.277H69.64v74.544H0v37.272h69.64v74.544h37.272v-74.544h69.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.bea3220e0bae2ca4ebbcd14e35ca7510.svg";
export { ForwardRef as ReactComponent };